
/********************************************************************************************************************
This application uses the google API for sheets. The page is leads from is
located here: https://docs.google.com/spreadsheets/d/1OwKALJeMkprkbY68iGrCvFUhU4ZascoDLaw34fzeYaA/edit#gid=514827396

The code must know the name of the sheet, and it loads from a specific are of the sheet.
the rages are on this array  ranges = ['!A3:E11', '!A15:E23' , '!A27:E35' , '!H3:L11' , '!H15:L23' ,'!H27:L35', 
'!A39:E47' ]; each range is a wave form type.

sheet names are in a look up function getSheetFromString based on the scanner code from the drop down. If a new 
sheet is to be added, the sheet should match the same layout and a new name needs to be given and added to the code. 
*******************************************************************************************************************/



//service accounts ----  https://stackoverflow.com/questions/27067825/how-to-access-google-spreadsheets-with-a-service-account-credentials

//bypassing api   https://stackoverflow.com/questions/4143901/how-can-i-access-google-sheet-spreadsheets-only-with-javascript
 
// Google sheets API
// YOUR_CLIENT_ID: 1058486166449-mt61tkp2c8tla0bvj88pqcq8f7jsant3.apps.googleusercontent.com
// YOUR_API_KEY: AIzaSyDhpfdUrxkwRqeHAxtTUqGp27m_bTukVLo
var CHART = null;
const CLIENT_ID = '1058486166449-nm54afjccenufpiu304ndlpgg0sj5l3k.apps.googleusercontent.com';
const API_KEY = 'AIzaSyBvdhzEBDyFaHI3M8uuIAQCILA-WAEuikc';
var client;
var access_token;
var ranges = ['!A3:E11', '!A15:E23' , '!A27:E35' , '!H3:L11' , '!H15:L23' , '!H27:L35', '!A39:E47' , '!H39:L47' ];
var dataRec = 0; 
document.querySelector(".Angle").value = "1";
//document.querySelector(".step").value = "100";
const canvasWrapper = document.getElementById('wrapper')
canvasWrapper.style.display = 'none'; 


/*********************
**********************
**  hand coded data **
**********************
* This needs to be   *
* here for a template*
**********************/

var C506_3MM =  
[
{WaveForm: "Sawtooth_70", Angle : [{DegOpt : 1, Freq :-4000,	Data : {"Heat_Scanner":0.1, "Heat_Amp":  4  , "Power_Cons":17  , "Tune_Notes":"" } },
									{DegOpt : 5, Freq :-4000,	Data : {"Heat_Scanner":1.9, "Heat_Amp":  18 , "Power_Cons":32.9, "Tune_Notes":"" } },
									{DegOpt : 10, Freq :1345,	Data : {"Heat_Scanner":8.4, "Heat_Amp":  27 , "Power_Cons":49.4, "Tune_Notes":"" } },
									{DegOpt : 15, Freq :1040,	Data : {"Heat_Scanner":7.9, "Heat_Amp":  21 , "Power_Cons":43.4, "Tune_Notes":"" } },
									{DegOpt : 20, Freq : 821,	Data : {"Heat_Scanner":6.4, "Heat_Amp":  17 , "Power_Cons":37.9, "Tune_Notes":"" } },
									{DegOpt : 30, Freq : 575,	Data : {"Heat_Scanner":4.2, "Heat_Amp":  12 , "Power_Cons":30.5, "Tune_Notes":"" } },
									{DegOpt : 40, Freq : 441,	Data : {"Heat_Scanner":3.5, "Heat_Amp":  8.8, "Power_Cons":26.4, "Tune_Notes":"" } },
									{DegOpt : 50, Freq : 441,	Data : {"Heat_Scanner":3.5, "Heat_Amp":  8.8, "Power_Cons":26.4, "Tune_Notes":"" } },
							        {DegOpt : 60, Freq : 352,	Data : {"Heat_Scanner":2.8, "Heat_Amp":  7.8, "Power_Cons":23.8, "Tune_Notes":"" } }] },
{WaveForm: "Sawtooth_80", Angle : [{DegOpt : 1, Freq :-4000,	Data : {"Heat_Scanner":0.1, "Heat_Amp":  4  , "Power_Cons":17  , "Tune_Notes":"" } },
									{DegOpt : 5, Freq :-4000,	Data : {"Heat_Scanner":1.9, "Heat_Amp":  18 , "Power_Cons":32.9, "Tune_Notes":"" } },
									{DegOpt : 10, Freq :1345,	Data : {"Heat_Scanner":8.4, "Heat_Amp":  27 , "Power_Cons":49.4, "Tune_Notes":"" } },
									{DegOpt : 15, Freq :1040,	Data : {"Heat_Scanner":7.9, "Heat_Amp":  21 , "Power_Cons":43.4, "Tune_Notes":"" } },
									{DegOpt : 20, Freq : 821,	Data : {"Heat_Scanner":6.4, "Heat_Amp":  17 , "Power_Cons":37.9, "Tune_Notes":"" } },
									{DegOpt : 30, Freq : 575,	Data : {"Heat_Scanner":4.2, "Heat_Amp":  12 , "Power_Cons":30.5, "Tune_Notes":"" } },
									{DegOpt : 40, Freq : 441,	Data : {"Heat_Scanner":3.5, "Heat_Amp":  8.8, "Power_Cons":26.4, "Tune_Notes":"" } },
									{DegOpt : 50, Freq : 441,	Data : {"Heat_Scanner":3.5, "Heat_Amp":  8.8, "Power_Cons":26.4, "Tune_Notes":"" } },
							        {DegOpt : 60, Freq : 352,	Data : {"Heat_Scanner":2.8, "Heat_Amp":  7.8, "Power_Cons":23.8, "Tune_Notes":"" } }] },
{WaveForm: "Sawtooth_90", Angle : [{DegOpt : 1, Freq :-4000,	Data : {"Heat_Scanner":0.1, "Heat_Amp":  4  , "Power_Cons":17  , "Tune_Notes":"" } },
									{DegOpt : 5, Freq :-4000,	Data : {"Heat_Scanner":1.9, "Heat_Amp":  18 , "Power_Cons":32.9, "Tune_Notes":"" } },
									{DegOpt : 10, Freq :1345,	Data : {"Heat_Scanner":8.4, "Heat_Amp":  27 , "Power_Cons":49.4, "Tune_Notes":"" } },
									{DegOpt : 15, Freq :1040,	Data : {"Heat_Scanner":7.9, "Heat_Amp":  21 , "Power_Cons":43.4, "Tune_Notes":"" } },
									{DegOpt : 20, Freq : 821,	Data : {"Heat_Scanner":6.4, "Heat_Amp":  17 , "Power_Cons":37.9, "Tune_Notes":"" } },
									{DegOpt : 30, Freq : 575,	Data : {"Heat_Scanner":4.2, "Heat_Amp":  12 , "Power_Cons":30.5, "Tune_Notes":"" } },
									{DegOpt : 40, Freq : 441,	Data : {"Heat_Scanner":3.5, "Heat_Amp":  8.8, "Power_Cons":26.4, "Tune_Notes":"" } },
									{DegOpt : 50, Freq : 441,	Data : {"Heat_Scanner":3.5, "Heat_Amp":  8.8, "Power_Cons":26.4, "Tune_Notes":"" } },
							        {DegOpt : 60, Freq : 352,	Data : {"Heat_Scanner":2.8, "Heat_Amp":  7.8, "Power_Cons":23.8, "Tune_Notes":"" } }] },
	 {WaveForm: "Cycloid", Angle : [{DegOpt : 1, Freq :-4000,	Data : {"Heat_Scanner":0.1, "Heat_Amp":  4  , "Power_Cons":17  , "Tune_Notes":"" } },
									{DegOpt : 5, Freq :-4000,	Data : {"Heat_Scanner":1.9, "Heat_Amp":  18 , "Power_Cons":32.9, "Tune_Notes":"" } },
									{DegOpt : 10, Freq :1345,	Data : {"Heat_Scanner":8.4, "Heat_Amp":  27 , "Power_Cons":49.4, "Tune_Notes":"" } },
									{DegOpt : 15, Freq :1040,	Data : {"Heat_Scanner":7.9, "Heat_Amp":  21 , "Power_Cons":43.4, "Tune_Notes":"" } },
									{DegOpt : 20, Freq : 821,	Data : {"Heat_Scanner":6.4, "Heat_Amp":  17 , "Power_Cons":37.9, "Tune_Notes":"" } },
									{DegOpt : 30, Freq : 575,	Data : {"Heat_Scanner":4.2, "Heat_Amp":  12 , "Power_Cons":30.5, "Tune_Notes":"" } },
									{DegOpt : 40, Freq : 441,	Data : {"Heat_Scanner":3.5, "Heat_Amp":  8.8, "Power_Cons":26.4, "Tune_Notes":"" } },
									{DegOpt : 50, Freq : 441,	Data : {"Heat_Scanner":3.5, "Heat_Amp":  8.8, "Power_Cons":26.4, "Tune_Notes":"" } },
							        {DegOpt : 60, Freq : 352,	Data : {"Heat_Scanner":2.8, "Heat_Amp":  7.8, "Power_Cons":23.8, "Tune_Notes":"" } }] },
	{WaveForm: "Triangle", Angle : [{DegOpt : 1, Freq :-4000,	Data : {"Heat_Scanner":0.1, "Heat_Amp":  4  , "Power_Cons":17  , "Tune_Notes":"" } },
									{DegOpt : 5, Freq :-4000,	Data : {"Heat_Scanner":1.9, "Heat_Amp":  18 , "Power_Cons":32.9, "Tune_Notes":"" } },
									{DegOpt : 10, Freq :1345,	Data : {"Heat_Scanner":8.4, "Heat_Amp":  27 , "Power_Cons":49.4, "Tune_Notes":"" } },
									{DegOpt : 15, Freq :1040,	Data : {"Heat_Scanner":7.9, "Heat_Amp":  21 , "Power_Cons":43.4, "Tune_Notes":"" } },
									{DegOpt : 20, Freq : 821,	Data : {"Heat_Scanner":6.4, "Heat_Amp":  17 , "Power_Cons":37.9, "Tune_Notes":"" } },
									{DegOpt : 30, Freq : 575,	Data : {"Heat_Scanner":4.2, "Heat_Amp":  12 , "Power_Cons":30.5, "Tune_Notes":"" } },
									{DegOpt : 40, Freq : 441,	Data : {"Heat_Scanner":3.5, "Heat_Amp":  8.8, "Power_Cons":26.4, "Tune_Notes":"" } },
									{DegOpt : 50, Freq : 441,	Data : {"Heat_Scanner":3.5, "Heat_Amp":  8.8, "Power_Cons":26.4, "Tune_Notes":"" } },
							        {DegOpt : 60, Freq : 352,	Data : {"Heat_Scanner":2.8, "Heat_Amp":  7.8, "Power_Cons":23.8, "Tune_Notes":"" } }] },
	  {WaveForm: "Square", Angle : [{DegOpt : 1, Freq :-4000,	Data : {"Heat_Scanner":0.1, "Heat_Amp":  4  , "Power_Cons":17  , "Tune_Notes":"" } },
									{DegOpt : 5, Freq :-4000,	Data : {"Heat_Scanner":1.9, "Heat_Amp":  18 , "Power_Cons":32.9, "Tune_Notes":"" } },
									{DegOpt : 10, Freq :1345,	Data : {"Heat_Scanner":8.4, "Heat_Amp":  27 , "Power_Cons":49.4, "Tune_Notes":"" } },
									{DegOpt : 15, Freq :1040,	Data : {"Heat_Scanner":7.9, "Heat_Amp":  21 , "Power_Cons":43.4, "Tune_Notes":"" } },
									{DegOpt : 20, Freq : 821,	Data : {"Heat_Scanner":6.4, "Heat_Amp":  17 , "Power_Cons":37.9, "Tune_Notes":"" } },
									{DegOpt : 30, Freq : 575,	Data : {"Heat_Scanner":4.2, "Heat_Amp":  12 , "Power_Cons":30.5, "Tune_Notes":"" } },
									{DegOpt : 40, Freq : 441,	Data : {"Heat_Scanner":3.5, "Heat_Amp":  8.8, "Power_Cons":26.4, "Tune_Notes":"" } },
									{DegOpt : 50, Freq : 441,	Data : {"Heat_Scanner":3.5, "Heat_Amp":  8.8, "Power_Cons":26.4, "Tune_Notes":"" } },
							        {DegOpt : 60, Freq : 352,	Data : {"Heat_Scanner":2.8, "Heat_Amp":  7.8, "Power_Cons":23.8, "Tune_Notes":"" } }] },
	  {WaveForm: "Sine", Angle   : [{DegOpt : 1, Freq :-4000,	Data : {"Heat_Scanner":0.1, "Heat_Amp":  4  , "Power_Cons":17  , "Tune_Notes":"" } },
									{DegOpt : 5, Freq :-4000,	Data : {"Heat_Scanner":1.9, "Heat_Amp":  18 , "Power_Cons":32.9, "Tune_Notes":"" } },
									{DegOpt : 10, Freq :1345,	Data : {"Heat_Scanner":8.4, "Heat_Amp":  27 , "Power_Cons":49.4, "Tune_Notes":"" } },
									{DegOpt : 15, Freq :1040,	Data : {"Heat_Scanner":7.9, "Heat_Amp":  21 , "Power_Cons":43.4, "Tune_Notes":"" } },
									{DegOpt : 20, Freq : 821,	Data : {"Heat_Scanner":6.4, "Heat_Amp":  17 , "Power_Cons":37.9, "Tune_Notes":"" } },
									{DegOpt : 30, Freq : 575,	Data : {"Heat_Scanner":4.2, "Heat_Amp":  12 , "Power_Cons":30.5, "Tune_Notes":"" } },
									{DegOpt : 40, Freq : 441,	Data : {"Heat_Scanner":3.5, "Heat_Amp":  8.8, "Power_Cons":26.4, "Tune_Notes":"" } },
									{DegOpt : 50, Freq : 441,	Data : {"Heat_Scanner":3.5, "Heat_Amp":  8.8, "Power_Cons":26.4, "Tune_Notes":"" } },
							        {DegOpt : 60, Freq : 352,	Data : {"Heat_Scanner":2.8, "Heat_Amp":  7.8, "Power_Cons":23.8, "Tune_Notes":"" } }] },
      {WaveForm: "Benner", Angle   : [{DegOpt : 1, Freq :-4000,	Data : {"Heat_Scanner":0.1, "Heat_Amp":  4  , "Power_Cons":17  , "Tune_Notes":"" } },
									{DegOpt : 5, Freq :-4000,	Data : {"Heat_Scanner":1.9, "Heat_Amp":  18 , "Power_Cons":32.9, "Tune_Notes":"" } },
									{DegOpt : 10, Freq :1345,	Data : {"Heat_Scanner":8.4, "Heat_Amp":  27 , "Power_Cons":49.4, "Tune_Notes":"" } },
									{DegOpt : 15, Freq :1040,	Data : {"Heat_Scanner":7.9, "Heat_Amp":  21 , "Power_Cons":43.4, "Tune_Notes":"" } },
									{DegOpt : 20, Freq : 821,	Data : {"Heat_Scanner":6.4, "Heat_Amp":  17 , "Power_Cons":37.9, "Tune_Notes":"" } },
									{DegOpt : 30, Freq : 575,	Data : {"Heat_Scanner":4.2, "Heat_Amp":  12 , "Power_Cons":30.5, "Tune_Notes":"" } },
									{DegOpt : 40, Freq : 441,	Data : {"Heat_Scanner":3.5, "Heat_Amp":  8.8, "Power_Cons":26.4, "Tune_Notes":"" } },
									{DegOpt : 50, Freq : 441,	Data : {"Heat_Scanner":3.5, "Heat_Amp":  8.8, "Power_Cons":26.4, "Tune_Notes":"" } },
							        {DegOpt : 60, Freq : 352,	Data : {"Heat_Scanner":2.8, "Heat_Amp":  7.8, "Power_Cons":23.8, "Tune_Notes":"" } }] }

];
C506_5MM = JSON.parse(JSON.stringify(C506_3MM));
C506_10MM = JSON.parse(JSON.stringify(C506_3MM));
ARC_5MM = JSON.parse(JSON.stringify(C506_3MM));
  
 
var SAT_3MM =   
[
{WaveForm: "Sawtooth_70", Angle : [{DegOpt : 1, Freq :-2000,	Data : {"Heat_Scanner":0.1, "Heat_Amp":  4  , "Power_Cons":17  , "Tune_Notes":"" } },
									{DegOpt : 5, Freq :1801,	Data : {"Heat_Scanner":1.9, "Heat_Amp":  18 , "Power_Cons":32.9, "Tune_Notes":"" } },
									{DegOpt : 10, Freq :1200,	Data : {"Heat_Scanner":8.4, "Heat_Amp":  27 , "Power_Cons":49.4, "Tune_Notes":"" } },
									{DegOpt : 15, Freq :1100,	Data : {"Heat_Scanner":7.9, "Heat_Amp":  21 , "Power_Cons":43.4, "Tune_Notes":"" } },
									{DegOpt : 20, Freq : 821,	Data : {"Heat_Scanner":6.4, "Heat_Amp":  17 , "Power_Cons":37.9, "Tune_Notes":"" } },
									{DegOpt : 30, Freq : 575,	Data : {"Heat_Scanner":4.2, "Heat_Amp":  12 , "Power_Cons":30.5, "Tune_Notes":"" } },
									{DegOpt : 40, Freq : 441,	Data : {"Heat_Scanner":3.5, "Heat_Amp":  8.8, "Power_Cons":26.4, "Tune_Notes":"" } },
									{DegOpt : 50, Freq : 441,	Data : {"Heat_Scanner":3.5, "Heat_Amp":  8.8, "Power_Cons":26.4, "Tune_Notes":"" } },
							        {DegOpt : 60, Freq : 352,	Data : {"Heat_Scanner":2.8, "Heat_Amp":  7.8, "Power_Cons":23.8, "Tune_Notes":"" } }] 
						 , Angle2 : [{DegOpt : 1, Freq :-2000,	Data : {"Heat_Scanner":0.1, "Heat_Amp":  4  , "Power_Cons":17  , "Tune_Notes":"" } },
									{DegOpt : 5, Freq :1802,	Data : {"Heat_Scanner":1.9, "Heat_Amp":  18 , "Power_Cons":32.9, "Tune_Notes":"" } },
									{DegOpt : 10, Freq :1200,	Data : {"Heat_Scanner":8.4, "Heat_Amp":  27 , "Power_Cons":49.4, "Tune_Notes":"" } },
									{DegOpt : 15, Freq :1100,	Data : {"Heat_Scanner":7.9, "Heat_Amp":  21 , "Power_Cons":43.4, "Tune_Notes":"" } },
									{DegOpt : 20, Freq : 821,	Data : {"Heat_Scanner":6.4, "Heat_Amp":  17 , "Power_Cons":37.9, "Tune_Notes":"" } },
									{DegOpt : 30, Freq : 575,	Data : {"Heat_Scanner":4.2, "Heat_Amp":  12 , "Power_Cons":30.5, "Tune_Notes":"" } },
									{DegOpt : 40, Freq : 441,	Data : {"Heat_Scanner":3.5, "Heat_Amp":  8.8, "Power_Cons":26.4, "Tune_Notes":"" } },
									{DegOpt : 50, Freq : 441,	Data : {"Heat_Scanner":3.5, "Heat_Amp":  8.8, "Power_Cons":26.4, "Tune_Notes":"" } },
							        {DegOpt : 60, Freq : 352,	Data : {"Heat_Scanner":2.8, "Heat_Amp":  7.8, "Power_Cons":23.8, "Tune_Notes":"" } }] 
																																					},
{WaveForm: "Sawtooth_80", Angle : [{DegOpt : 1, Freq :-2000,	Data : {"Heat_Scanner":0.1, "Heat_Amp":  4  , "Power_Cons":17  , "Tune_Notes":"" } },
									{DegOpt : 5, Freq :1800,	Data : {"Heat_Scanner":1.9, "Heat_Amp":  18 , "Power_Cons":32.9, "Tune_Notes":"" } },
									{DegOpt : 10, Freq :1200,	Data : {"Heat_Scanner":8.4, "Heat_Amp":  27 , "Power_Cons":49.4, "Tune_Notes":"" } },
									{DegOpt : 15, Freq :1100,	Data : {"Heat_Scanner":7.9, "Heat_Amp":  21 , "Power_Cons":43.4, "Tune_Notes":"" } },
									{DegOpt : 20, Freq : 821,	Data : {"Heat_Scanner":6.4, "Heat_Amp":  17 , "Power_Cons":37.9, "Tune_Notes":"" } },
									{DegOpt : 30, Freq : 575,	Data : {"Heat_Scanner":4.2, "Heat_Amp":  12 , "Power_Cons":30.5, "Tune_Notes":"" } },
									{DegOpt : 40, Freq : 441,	Data : {"Heat_Scanner":3.5, "Heat_Amp":  8.8, "Power_Cons":26.4, "Tune_Notes":"" } },
									{DegOpt : 50, Freq : 441,	Data : {"Heat_Scanner":3.5, "Heat_Amp":  8.8, "Power_Cons":26.4, "Tune_Notes":"" } },
							        {DegOpt : 60, Freq : 352,	Data : {"Heat_Scanner":2.8, "Heat_Amp":  7.8, "Power_Cons":23.8, "Tune_Notes":"" } }] 
						 , Angle2 : [{DegOpt : 1, Freq :-2000,	Data : {"Heat_Scanner":0.1, "Heat_Amp":  4  , "Power_Cons":17  , "Tune_Notes":"" } },
									{DegOpt : 5, Freq :1800,	Data : {"Heat_Scanner":1.9, "Heat_Amp":  18 , "Power_Cons":32.9, "Tune_Notes":"" } },
									{DegOpt : 10, Freq :1200,	Data : {"Heat_Scanner":8.4, "Heat_Amp":  27 , "Power_Cons":49.4, "Tune_Notes":"" } },
									{DegOpt : 15, Freq :1100,	Data : {"Heat_Scanner":7.9, "Heat_Amp":  21 , "Power_Cons":43.4, "Tune_Notes":"" } },
									{DegOpt : 20, Freq : 821,	Data : {"Heat_Scanner":6.4, "Heat_Amp":  17 , "Power_Cons":37.9, "Tune_Notes":"" } },
									{DegOpt : 30, Freq : 575,	Data : {"Heat_Scanner":4.2, "Heat_Amp":  12 , "Power_Cons":30.5, "Tune_Notes":"" } },
									{DegOpt : 40, Freq : 441,	Data : {"Heat_Scanner":3.5, "Heat_Amp":  8.8, "Power_Cons":26.4, "Tune_Notes":"" } },
									{DegOpt : 50, Freq : 441,	Data : {"Heat_Scanner":3.5, "Heat_Amp":  8.8, "Power_Cons":26.4, "Tune_Notes":"" } },
							        {DegOpt : 60, Freq : 352,	Data : {"Heat_Scanner":2.8, "Heat_Amp":  7.8, "Power_Cons":23.8, "Tune_Notes":"" } }] 
																																					},
{WaveForm: "Sawtooth_90", Angle : [{DegOpt : 1, Freq :-2000,	Data : {"Heat_Scanner":0.1, "Heat_Amp":  4  , "Power_Cons":17  , "Tune_Notes":"" } },
									{DegOpt : 5, Freq :1800,	Data : {"Heat_Scanner":1.9, "Heat_Amp":  18 , "Power_Cons":32.9, "Tune_Notes":"" } },
									{DegOpt : 10, Freq :1200,	Data : {"Heat_Scanner":8.4, "Heat_Amp":  27 , "Power_Cons":49.4, "Tune_Notes":"" } },
									{DegOpt : 15, Freq :1100,	Data : {"Heat_Scanner":7.9, "Heat_Amp":  21 , "Power_Cons":43.4, "Tune_Notes":"" } },
									{DegOpt : 20, Freq : 821,	Data : {"Heat_Scanner":6.4, "Heat_Amp":  17 , "Power_Cons":37.9, "Tune_Notes":"" } },
									{DegOpt : 30, Freq : 575,	Data : {"Heat_Scanner":4.2, "Heat_Amp":  12 , "Power_Cons":30.5, "Tune_Notes":"" } },
									{DegOpt : 40, Freq : 441,	Data : {"Heat_Scanner":3.5, "Heat_Amp":  8.8, "Power_Cons":26.4, "Tune_Notes":"" } },
									{DegOpt : 50, Freq : 441,	Data : {"Heat_Scanner":3.5, "Heat_Amp":  8.8, "Power_Cons":26.4, "Tune_Notes":"" } },
							        {DegOpt : 60, Freq : 352,	Data : {"Heat_Scanner":2.8, "Heat_Amp":  7.8, "Power_Cons":23.8, "Tune_Notes":"" } }] 
						 , Angle2 : [{DegOpt : 1, Freq :-2000,	Data : {"Heat_Scanner":0.1, "Heat_Amp":  4  , "Power_Cons":17  , "Tune_Notes":"" } },
									{DegOpt : 5, Freq :1800,	Data : {"Heat_Scanner":1.9, "Heat_Amp":  18 , "Power_Cons":32.9, "Tune_Notes":"" } },
									{DegOpt : 10, Freq :1200,	Data : {"Heat_Scanner":8.4, "Heat_Amp":  27 , "Power_Cons":49.4, "Tune_Notes":"" } },
									{DegOpt : 15, Freq :1100,	Data : {"Heat_Scanner":7.9, "Heat_Amp":  21 , "Power_Cons":43.4, "Tune_Notes":"" } },
									{DegOpt : 20, Freq : 821,	Data : {"Heat_Scanner":6.4, "Heat_Amp":  17 , "Power_Cons":37.9, "Tune_Notes":"" } },
									{DegOpt : 30, Freq : 575,	Data : {"Heat_Scanner":4.2, "Heat_Amp":  12 , "Power_Cons":30.5, "Tune_Notes":"" } },
									{DegOpt : 40, Freq : 441,	Data : {"Heat_Scanner":3.5, "Heat_Amp":  8.8, "Power_Cons":26.4, "Tune_Notes":"" } },
									{DegOpt : 50, Freq : 441,	Data : {"Heat_Scanner":3.5, "Heat_Amp":  8.8, "Power_Cons":26.4, "Tune_Notes":"" } },
							        {DegOpt : 60, Freq : 352,	Data : {"Heat_Scanner":2.8, "Heat_Amp":  7.8, "Power_Cons":23.8, "Tune_Notes":"" } }] 
																																					},
{WaveForm: "Cycloid", Angle : [{DegOpt : 1, Freq :-2000,	Data : {"Heat_Scanner":0.1, "Heat_Amp":  4  , "Power_Cons":17  , "Tune_Notes":"" } },
									{DegOpt : 5, Freq :1800,	Data : {"Heat_Scanner":1.9, "Heat_Amp":  18 , "Power_Cons":32.9, "Tune_Notes":"" } },
									{DegOpt : 10, Freq :1200,	Data : {"Heat_Scanner":8.4, "Heat_Amp":  27 , "Power_Cons":49.4, "Tune_Notes":"" } },
									{DegOpt : 15, Freq :1100,	Data : {"Heat_Scanner":7.9, "Heat_Amp":  21 , "Power_Cons":43.4, "Tune_Notes":"" } },
									{DegOpt : 20, Freq : 821,	Data : {"Heat_Scanner":6.4, "Heat_Amp":  17 , "Power_Cons":37.9, "Tune_Notes":"" } },
									{DegOpt : 30, Freq : 575,	Data : {"Heat_Scanner":4.2, "Heat_Amp":  12 , "Power_Cons":30.5, "Tune_Notes":"" } },
									{DegOpt : 40, Freq : 441,	Data : {"Heat_Scanner":3.5, "Heat_Amp":  8.8, "Power_Cons":26.4, "Tune_Notes":"" } },
									{DegOpt : 50, Freq : 441,	Data : {"Heat_Scanner":3.5, "Heat_Amp":  8.8, "Power_Cons":26.4, "Tune_Notes":"" } },
							        {DegOpt : 60, Freq : 352,	Data : {"Heat_Scanner":2.8, "Heat_Amp":  7.8, "Power_Cons":23.8, "Tune_Notes":"" } }] 
						 , Angle2 : [{DegOpt : 1, Freq :-2000,	Data : {"Heat_Scanner":0.1, "Heat_Amp":  4  , "Power_Cons":17  , "Tune_Notes":"" } },
									{DegOpt : 5, Freq :1800,	Data : {"Heat_Scanner":1.9, "Heat_Amp":  18 , "Power_Cons":32.9, "Tune_Notes":"" } },
									{DegOpt : 10, Freq :1200,	Data : {"Heat_Scanner":8.4, "Heat_Amp":  27 , "Power_Cons":49.4, "Tune_Notes":"" } },
									{DegOpt : 15, Freq :1100,	Data : {"Heat_Scanner":7.9, "Heat_Amp":  21 , "Power_Cons":43.4, "Tune_Notes":"" } },
									{DegOpt : 20, Freq : 821,	Data : {"Heat_Scanner":6.4, "Heat_Amp":  17 , "Power_Cons":37.9, "Tune_Notes":"" } },
									{DegOpt : 30, Freq : 575,	Data : {"Heat_Scanner":4.2, "Heat_Amp":  12 , "Power_Cons":30.5, "Tune_Notes":"" } },
									{DegOpt : 40, Freq : 441,	Data : {"Heat_Scanner":3.5, "Heat_Amp":  8.8, "Power_Cons":26.4, "Tune_Notes":"" } },
									{DegOpt : 50, Freq : 441,	Data : {"Heat_Scanner":3.5, "Heat_Amp":  8.8, "Power_Cons":26.4, "Tune_Notes":"" } },
							        {DegOpt : 60, Freq : 352,	Data : {"Heat_Scanner":2.8, "Heat_Amp":  7.8, "Power_Cons":23.8, "Tune_Notes":"" } }] 
																																					},
	{WaveForm: "Triangle", Angle : [{DegOpt : 1, Freq :-2000,	Data : {"Heat_Scanner":0.1, "Heat_Amp":  4  , "Power_Cons":17  , "Tune_Notes":"" } },
									{DegOpt : 5, Freq :1800,	Data : {"Heat_Scanner":1.9, "Heat_Amp":  18 , "Power_Cons":32.9, "Tune_Notes":"" } },
									{DegOpt : 10, Freq :1200,	Data : {"Heat_Scanner":8.4, "Heat_Amp":  27 , "Power_Cons":49.4, "Tune_Notes":"" } },
									{DegOpt : 15, Freq :1100,	Data : {"Heat_Scanner":7.9, "Heat_Amp":  21 , "Power_Cons":43.4, "Tune_Notes":"" } },
									{DegOpt : 20, Freq : 821,	Data : {"Heat_Scanner":6.4, "Heat_Amp":  17 , "Power_Cons":37.9, "Tune_Notes":"" } },
									{DegOpt : 30, Freq : 575,	Data : {"Heat_Scanner":4.2, "Heat_Amp":  12 , "Power_Cons":30.5, "Tune_Notes":"" } },
									{DegOpt : 40, Freq : 441,	Data : {"Heat_Scanner":3.5, "Heat_Amp":  8.8, "Power_Cons":26.4, "Tune_Notes":"" } },
									{DegOpt : 50, Freq : 441,	Data : {"Heat_Scanner":3.5, "Heat_Amp":  8.8, "Power_Cons":26.4, "Tune_Notes":"" } },
							        {DegOpt : 60, Freq : 352,	Data : {"Heat_Scanner":2.8, "Heat_Amp":  7.8, "Power_Cons":23.8, "Tune_Notes":"" } }] 
						 , Angle2 : [{DegOpt : 1, Freq :-2000,	Data : {"Heat_Scanner":0.1, "Heat_Amp":  4  , "Power_Cons":17  , "Tune_Notes":"" } },
									{DegOpt : 5, Freq :1800,	Data : {"Heat_Scanner":1.9, "Heat_Amp":  18 , "Power_Cons":32.9, "Tune_Notes":"" } },
									{DegOpt : 10, Freq :1200,	Data : {"Heat_Scanner":8.4, "Heat_Amp":  27 , "Power_Cons":49.4, "Tune_Notes":"" } },
									{DegOpt : 15, Freq :1100,	Data : {"Heat_Scanner":7.9, "Heat_Amp":  21 , "Power_Cons":43.4, "Tune_Notes":"" } },
									{DegOpt : 20, Freq : 821,	Data : {"Heat_Scanner":6.4, "Heat_Amp":  17 , "Power_Cons":37.9, "Tune_Notes":"" } },
									{DegOpt : 30, Freq : 575,	Data : {"Heat_Scanner":4.2, "Heat_Amp":  12 , "Power_Cons":30.5, "Tune_Notes":"" } },
									{DegOpt : 40, Freq : 441,	Data : {"Heat_Scanner":3.5, "Heat_Amp":  8.8, "Power_Cons":26.4, "Tune_Notes":"" } },
									{DegOpt : 50, Freq : 441,	Data : {"Heat_Scanner":3.5, "Heat_Amp":  8.8, "Power_Cons":26.4, "Tune_Notes":"" } },
							        {DegOpt : 60, Freq : 352,	Data : {"Heat_Scanner":2.8, "Heat_Amp":  7.8, "Power_Cons":23.8, "Tune_Notes":"" } }] 
																																					},
	  {WaveForm: "Square", Angle : [{DegOpt : 1, Freq :-2000,	Data : {"Heat_Scanner":0.1, "Heat_Amp":  4  , "Power_Cons":17  , "Tune_Notes":"" } },
									{DegOpt : 5, Freq :1800,	Data : {"Heat_Scanner":1.9, "Heat_Amp":  18 , "Power_Cons":32.9, "Tune_Notes":"" } },
									{DegOpt : 10, Freq :1200,	Data : {"Heat_Scanner":8.4, "Heat_Amp":  27 , "Power_Cons":49.4, "Tune_Notes":"" } },
									{DegOpt : 15, Freq :1100,	Data : {"Heat_Scanner":7.9, "Heat_Amp":  21 , "Power_Cons":43.4, "Tune_Notes":"" } },
									{DegOpt : 20, Freq : 821,	Data : {"Heat_Scanner":6.4, "Heat_Amp":  17 , "Power_Cons":37.9, "Tune_Notes":"" } },
									{DegOpt : 30, Freq : 575,	Data : {"Heat_Scanner":4.2, "Heat_Amp":  12 , "Power_Cons":30.5, "Tune_Notes":"" } },
									{DegOpt : 40, Freq : 441,	Data : {"Heat_Scanner":3.5, "Heat_Amp":  8.8, "Power_Cons":26.4, "Tune_Notes":"" } },
									{DegOpt : 50, Freq : 441,	Data : {"Heat_Scanner":3.5, "Heat_Amp":  8.8, "Power_Cons":26.4, "Tune_Notes":"" } },
							        {DegOpt : 60, Freq : 352,	Data : {"Heat_Scanner":2.8, "Heat_Amp":  7.8, "Power_Cons":23.8, "Tune_Notes":"" } }] 
						 , Angle2 : [{DegOpt : 1, Freq :-2000,	Data : {"Heat_Scanner":0.1, "Heat_Amp":  4  , "Power_Cons":17  , "Tune_Notes":"" } },
									{DegOpt : 5, Freq :1800,	Data : {"Heat_Scanner":1.9, "Heat_Amp":  18 , "Power_Cons":32.9, "Tune_Notes":"" } },
									{DegOpt : 10, Freq :1200,	Data : {"Heat_Scanner":8.4, "Heat_Amp":  27 , "Power_Cons":49.4, "Tune_Notes":"" } },
									{DegOpt : 15, Freq :1100,	Data : {"Heat_Scanner":7.9, "Heat_Amp":  21 , "Power_Cons":43.4, "Tune_Notes":"" } },
									{DegOpt : 20, Freq : 821,	Data : {"Heat_Scanner":6.4, "Heat_Amp":  17 , "Power_Cons":37.9, "Tune_Notes":"" } },
									{DegOpt : 30, Freq : 575,	Data : {"Heat_Scanner":4.2, "Heat_Amp":  12 , "Power_Cons":30.5, "Tune_Notes":"" } },
									{DegOpt : 40, Freq : 441,	Data : {"Heat_Scanner":3.5, "Heat_Amp":  8.8, "Power_Cons":26.4, "Tune_Notes":"" } },
									{DegOpt : 50, Freq : 441,	Data : {"Heat_Scanner":3.5, "Heat_Amp":  8.8, "Power_Cons":26.4, "Tune_Notes":"" } },
							        {DegOpt : 60, Freq : 352,	Data : {"Heat_Scanner":2.8, "Heat_Amp":  7.8, "Power_Cons":23.8, "Tune_Notes":"" } }] 
																																					},
	  {WaveForm: "sine", Angle :    [{DegOpt : 1, Freq :-2000,	Data : {"Heat_Scanner":0.1, "Heat_Amp":  4  , "Power_Cons":17  , "Tune_Notes":"" } },
									{DegOpt : 5, Freq :1800,	Data : {"Heat_Scanner":1.9, "Heat_Amp":  18 , "Power_Cons":32.9, "Tune_Notes":"" } },
									{DegOpt : 10, Freq :1200,	Data : {"Heat_Scanner":8.4, "Heat_Amp":  27 , "Power_Cons":49.4, "Tune_Notes":"" } },
									{DegOpt : 15, Freq :1100,	Data : {"Heat_Scanner":7.9, "Heat_Amp":  21 , "Power_Cons":43.4, "Tune_Notes":"" } },
									{DegOpt : 20, Freq : 821,	Data : {"Heat_Scanner":6.4, "Heat_Amp":  17 , "Power_Cons":37.9, "Tune_Notes":"" } },
									{DegOpt : 30, Freq : 575,	Data : {"Heat_Scanner":4.2, "Heat_Amp":  12 , "Power_Cons":30.5, "Tune_Notes":"" } },
									{DegOpt : 40, Freq : 441,	Data : {"Heat_Scanner":3.5, "Heat_Amp":  8.8, "Power_Cons":26.4, "Tune_Notes":"" } },
									{DegOpt : 50, Freq : 441,	Data : {"Heat_Scanner":3.5, "Heat_Amp":  8.8, "Power_Cons":26.4, "Tune_Notes":"" } },
							        {DegOpt : 60, Freq : 352,	Data : {"Heat_Scanner":2.8, "Heat_Amp":  7.8, "Power_Cons":23.8, "Tune_Notes":"" } }] 
						 , Angle2 : [{DegOpt : 1, Freq :-2000,	Data : {"Heat_Scanner":0.1, "Heat_Amp":  4  , "Power_Cons":17  , "Tune_Notes":"" } },
									{DegOpt : 5, Freq :1800,	Data : {"Heat_Scanner":1.9, "Heat_Amp":  18 , "Power_Cons":32.9, "Tune_Notes":"" } },
									{DegOpt : 10, Freq :1200,	Data : {"Heat_Scanner":8.4, "Heat_Amp":  27 , "Power_Cons":49.4, "Tune_Notes":"" } },
									{DegOpt : 15, Freq :1100,	Data : {"Heat_Scanner":7.9, "Heat_Amp":  21 , "Power_Cons":43.4, "Tune_Notes":"" } },
									{DegOpt : 20, Freq : 821,	Data : {"Heat_Scanner":6.4, "Heat_Amp":  17 , "Power_Cons":37.9, "Tune_Notes":"" } },
									{DegOpt : 30, Freq : 575,	Data : {"Heat_Scanner":4.2, "Heat_Amp":  12 , "Power_Cons":30.5, "Tune_Notes":"" } },
									{DegOpt : 40, Freq : 441,	Data : {"Heat_Scanner":3.5, "Heat_Amp":  8.8, "Power_Cons":26.4, "Tune_Notes":"" } },
									{DegOpt : 50, Freq : 441,	Data : {"Heat_Scanner":3.5, "Heat_Amp":  8.8, "Power_Cons":26.4, "Tune_Notes":"" } },
							        {DegOpt : 60, Freq : 352,	Data : {"Heat_Scanner":2.8, "Heat_Amp":  7.8, "Power_Cons":23.8, "Tune_Notes":"" } }]  },
  	  {WaveForm: "Benner", Angle : [{DegOpt : 1, Freq :-2000,	Data : {"Heat_Scanner":0.1, "Heat_Amp":  4  , "Power_Cons":17  , "Tune_Notes":"" } },
									{DegOpt : 5, Freq :1800,	Data : {"Heat_Scanner":1.9, "Heat_Amp":  18 , "Power_Cons":32.9, "Tune_Notes":"" } },
									{DegOpt : 10, Freq :1200,	Data : {"Heat_Scanner":8.4, "Heat_Amp":  27 , "Power_Cons":49.4, "Tune_Notes":"" } },
									{DegOpt : 15, Freq :1100,	Data : {"Heat_Scanner":7.9, "Heat_Amp":  21 , "Power_Cons":43.4, "Tune_Notes":"" } },
									{DegOpt : 20, Freq : 821,	Data : {"Heat_Scanner":6.4, "Heat_Amp":  17 , "Power_Cons":37.9, "Tune_Notes":"" } },
									{DegOpt : 30, Freq : 575,	Data : {"Heat_Scanner":4.2, "Heat_Amp":  12 , "Power_Cons":30.5, "Tune_Notes":"" } },
									{DegOpt : 40, Freq : 441,	Data : {"Heat_Scanner":3.5, "Heat_Amp":  8.8, "Power_Cons":26.4, "Tune_Notes":"" } },
									{DegOpt : 50, Freq : 441,	Data : {"Heat_Scanner":3.5, "Heat_Amp":  8.8, "Power_Cons":26.4, "Tune_Notes":"" } },
							        {DegOpt : 60, Freq : 352,	Data : {"Heat_Scanner":2.8, "Heat_Amp":  7.8, "Power_Cons":23.8, "Tune_Notes":"" } }] 
						 , Angle2 : [{DegOpt : 1, Freq :-2000,	Data : {"Heat_Scanner":0.1, "Heat_Amp":  4  , "Power_Cons":17  , "Tune_Notes":"" } },
									{DegOpt : 5, Freq :1800,	Data : {"Heat_Scanner":1.9, "Heat_Amp":  18 , "Power_Cons":32.9, "Tune_Notes":"" } },
									{DegOpt : 10, Freq :1200,	Data : {"Heat_Scanner":8.4, "Heat_Amp":  27 , "Power_Cons":49.4, "Tune_Notes":"" } },
									{DegOpt : 15, Freq :1100,	Data : {"Heat_Scanner":7.9, "Heat_Amp":  21 , "Power_Cons":43.4, "Tune_Notes":"" } },
									{DegOpt : 20, Freq : 821,	Data : {"Heat_Scanner":6.4, "Heat_Amp":  17 , "Power_Cons":37.9, "Tune_Notes":"" } },
									{DegOpt : 30, Freq : 575,	Data : {"Heat_Scanner":4.2, "Heat_Amp":  12 , "Power_Cons":30.5, "Tune_Notes":"" } },
									{DegOpt : 40, Freq : 441,	Data : {"Heat_Scanner":3.5, "Heat_Amp":  8.8, "Power_Cons":26.4, "Tune_Notes":"" } },
									{DegOpt : 50, Freq : 441,	Data : {"Heat_Scanner":3.5, "Heat_Amp":  8.8, "Power_Cons":26.4, "Tune_Notes":"" } },
							        {DegOpt : 60, Freq : 352,	Data : {"Heat_Scanner":2.8, "Heat_Amp":  7.8, "Power_Cons":23.8, "Tune_Notes":"" } }]  }
];

SAT_5MM = JSON.parse(JSON.stringify(SAT_3MM));
SAT_10MM = JSON.parse(JSON.stringify(SAT_3MM));


/****************
*****************
**  google API **
*****************
*****************/
  
function C506PopulateData(DataSet, wabeFormType,  Data)
{
 
	for ( var d = 0; d < Data.length ; d++) 
	{
 
		DataSet[wabeFormType].Angle[d].DegOpt = Data[d][0]; 
		DataSet[wabeFormType].Angle[d].Freq   = Data[d][1];  
		DataSet[wabeFormType].Angle[d].Data.Heat_Scanner = Data[d][2];  
		DataSet[wabeFormType].Angle[d].Data.Heat_Amp     = Data[d][3];  
		DataSet[wabeFormType].Angle[d].Data.Power_Cons   = Data[d][4]; 
	}
}
function SaturnPopulateData(DataSet, wabeFormType,  Data, angleBlock)
{
 
  for ( var d = 0; d < Data.length ; d++) 
  {
      if (angleBlock == 0)
      {
          DataSet[wabeFormType].Angle[d].DegOpt = Data[d][0]; 
          DataSet[wabeFormType].Angle[d].Freq   = Data[d][1];  
          DataSet[wabeFormType].Angle[d].Data.Heat_Scanner = Data[d][2];  
          DataSet[wabeFormType].Angle[d].Data.Heat_Amp     = Data[d][3];  
          DataSet[wabeFormType].Angle[d].Data.Power_Cons   = Data[d][4]; 
      }
      if (angleBlock == 1)
      {
          DataSet[wabeFormType].Angle2[d].DegOpt = Data[d][0]; 
          DataSet[wabeFormType].Angle2[d].Freq   = Data[d][1];  
          DataSet[wabeFormType].Angle2[d].Data.Heat_Scanner = Data[d][2];  
          DataSet[wabeFormType].Angle2[d].Data.Heat_Amp     = Data[d][3];  
          DataSet[wabeFormType].Angle2[d].Data.Power_Cons   = Data[d][4]; 
      }
  }
		
}


function postJWT(jwt, callback) 
{
  var xhttp = new XMLHttpRequest();
  xhttp.onreadystatechange = function () {
      if (this.readyState == 4) {
          if (this.status == 200 && callback) {
              callback(this.responseText);
              return;
          }
          if (console) console.log(this.responseText);
      }
  };
  var parameters = "grant_type=" + encodeURIComponent("urn:ietf:params:oauth:grant-type:jwt-bearer") + "&assertion=" + encodeURIComponent(jwt);
  xhttp.open("POST", "https://www.googleapis.com/oauth2/v4/token", true);
  xhttp.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
  xhttp.send(parameters);
}

function getCert() 
{
  var cert = //your json key (downloaded earlier) goes here
      {
          "type": "service_account",
          "project_id": "seans-scannermax-api",
          "private_key_id": "40d25c3928e4760041826c5efd13a0b8fe8313d9",
          "private_key": "-----BEGIN PRIVATE KEY-----\nMIIEvAIBADANBgkqhkiG9w0BAQEFAASCBKYwggSiAgEAAoIBAQCdN10OoWlVwMt3\nQLsCdsJ3HSaBWAqJhcbejhoXUpLRPSgyYpUDU1ivLzMtYl0pSaxe9BIPyESN/ymW\nrx2oOWgV191phHq+/Ry56ZIRLWneRYk+B4qLXssiHS0inEY6s8evcBTZC6Pgqgua\nButrvbQihbKxMXDus776nCurvZUp2WBteEsY5jWbvB8EF3HDzQlQy8ZBNvE9HKDi\nJEdYIuV7lORr9EHMkv5T84svITGAFV0nvQDOf4SMqdU0xqrpfKV8wzrDKuAerku9\n3H8yktPHA8BF0XrfOQUqOkhKXdmlMPR4n+XD1iGaA3ZpVCNBD1x5PypUeoOeTE0n\n7CbhHBA3AgMBAAECgf8Wst3Gg+n2WhDe9arPa1Yejb5GZKD5dSXowP4DYAY1CDMe\nJuKEP8lJMwdhywMehqIXia+IDfXX7Qkd/VHyPM3AgP3jDPir6VWovQaLEeXyO2ay\n0u3BlAusYTtAksW4ZTyM+lzNIOr0jtOn1bpi3bvzGKlbddHOfZtaMR5ryumg3Aed\nvllXrA1pMzjXiPYdFFbZS2vJrUPf6kNSL6I9aIyezWN0Bn7lzHM0qZjyojOjgOsw\nijHs5yJ/OhPSqso99OE55qlq51Ca1J1JbXb6ehVwQrjqhskdz25RCHJCfjmRMbdQ\nhUDrc0Pvccpc5iHkGuM3U00ji07T+IfwvhAr2K0CgYEA2JOCte75J97ag5sPscdm\n/CZX1jmxW5V54TxFaDTts9uy/gSuNOPVhOLtbMe7Iu9cnwVdlpra8SnG63bkTTK7\nz7oOx5qA59KhQOm1hyUIc/srPvTcXbWQLHH7MJNpquBUe/E8XwLhS103lHU7FO5U\n+KTfB6dWDavsVrVax80bOwMCgYEAudWrPCB011oqvgQnNtT05XAebCDzPJc0Cv+6\n9LH3hRJkXqPOy6TnSXYa7bCnWjLc1ysvMsRp0eHYzsINAV+I2Uo3fXjtWs2THbqN\n6tn/sAhUD60AxRA4opBFh7Ok58I5nCoculB10bPAMiOI+N5FHSSumXeaTpt3UNXm\n24v41b0CgYEA1dR+n6Z8tZLgaEP2sO5Rje9FliuMIwJoPavGU2a+sm/eP9LbNTkl\nnXh4NojVCV8PMaqYhpQKS0WWMvFF47qNmED5SrYPQ9PAhli5c99qgyifwB7+XD9h\nQ6CeA43oLGAkyeKaWqx7SG+W6qr8VGQj3QLbebEL05/FTq7sHI0zr4UCgYEAh/Ci\nu3AuqJ4/6BJXsUelAfW7e3O7GxasrmMWGwvYuhKTM5v2mYe+3UE1P6zbLyNH42qm\nsyd1FWB13gGby+Zb0D/3SaTdVHBPbw7Z4/Omk9nzzCfNCVrtYxXQlw0104eD5xXz\nP+O93DH2pXbTKuJFgqUjyAXy7g/R/2MJ5o6E760CgYBnE/8rqhQ01iMMaFjn5IFv\nfRelNOa5Kq8DtsttEk/sKR4Ss3tjnAzuBwKxJJ2eb6dzkhKXC17sjn4PaHMCs/nx\nIlZcDnD7/U2/+i7/cERTLcae4WXFGRS1G1klZwZjdZEl9P3rRepbqTJCxKGp5foP\n5JZbScoOenSZATq6Ci3B2g==\n-----END PRIVATE KEY-----\n",
          "client_email": "webaccess@seans-scannermax-api.iam.gserviceaccount.com",
          "client_id": "100772222311971593516",
          "auth_uri": "https://accounts.google.com/o/oauth2/auth",
          "token_uri": "https://oauth2.googleapis.com/token",
          "auth_provider_x509_cert_url": "https://www.googleapis.com/oauth2/v1/certs",
          "client_x509_cert_url": "https://www.googleapis.com/robot/v1/metadata/x509/webaccess%40seans-scannermax-api.iam.gserviceaccount.com",
          "universe_domain": "googleapis.com"
      };      
  return cert;
}

function getJWT() 
{
    var cert = getCert();
    var key = KEYUTIL.getKey(cert.private_key);
    var headers = { "alg": "RS256", "typ": "JWT" };
    var issued = Math.floor(new Date().getTime()/1000);

    var claims = {
        "iss": cert.client_email,
        "scope": "https://www.googleapis.com/auth/analytics.readonly",
        "aud": "https://www.googleapis.com/oauth2/v4/token",
        "exp": issued + 3600,
        "iat": issued
    };

    var jwt = KJUR.jws.JWS.sign(headers.alg, headers, JSON.stringify(claims), key);
    return jwt;
}

function initTokenClient() 
{ 
	postJWT( getJWT(), function(response){
	access_token = JSON.parse(response).access_token;
	gapi.load('client', intializeGapiClient); 
	});
}
 
async function intializeGapiClient() 
{
    await gapi.client.init({
        apiKey: API_KEY,
        discoveryDocs: ["https://sheets.googleapis.com/$discovery/rest?version=v4"],
    });
    gapiInited = true;

    //assumes compact 506 is first
    getData( getTableFromString(document.querySelector(".Scanner").value ) ,document.querySelector(".Waveform").selectedIndex, getSheetFromString(document.querySelector(".Scanner").value) + ranges[document.querySelector(".Waveform").selectedIndex]); 
}
 
async function getData(DataSet, wabeFormType, range, AngleBlock ) 
{ 
    let response;
    try {
      // Fetch first 10 files
      response = await gapi.client.sheets.spreadsheets.values.get({
        spreadsheetId: '1OwKALJeMkprkbY68iGrCvFUhU4ZascoDLaw34fzeYaA', 
        range: range,
        headers: {
               'Authorization': 'Bearer ' + access_token
            }
      });
    } catch (err) {
       alert(">"+ err.body);		 
      return;
    }

    ///dual graph version
    if ( ! isScannerNameDouble(range) ) C506PopulateData( DataSet, wabeFormType,  response.result.values);		

      //single version
    else  SaturnPopulateData( DataSet, wabeFormType,  response.result.values, AngleBlock);	

    dataRec
    if (AngleBlock == undefined ) DisplayResuls( );
    else
    {
        if (AngleBlock == 0) dataRec ++;
        if (AngleBlock == 1) dataRec ++;
        if (dataRec == 2)
        {
            dataRec=0;
            DisplayResuls( )  //we do not know the order so wait for both then draw. 
        }			
    }

}
	
	
/****************
*****************
**  jschart    **
*****************
*****************/
   

DrawChart = function (inData,inDataAlt, inName, type, step)
{
 

	var name = getSheetFromString(inName);
 
    canvasWrapper.style.display = 'block'; 
	var labelData = new Array();
	var  Data = new Array();
	var  DataAlt = new Array();
	var simData = new Array();
   
    if ( document.querySelector(".Waveform").selectedIndex == 0 ) graph = 'Sawtooth 80% Duty Cycle'
    if ( document.querySelector(".Waveform").selectedIndex == 1 ) graph = 'Sawtooth 70% Duty Cycle'
    if ( document.querySelector(".Waveform").selectedIndex == 2 ) graph = 'Sawtooth 90% Duty Cycle'
    if ( document.querySelector(".Waveform").selectedIndex == 3 ) graph = 'Cycloid'
    if ( document.querySelector(".Waveform").selectedIndex == 4 ) graph = 'Triangle Wave'
    if ( document.querySelector(".Waveform").selectedIndex == 5 ) graph = 'Square Wave'
    if ( document.querySelector(".Waveform").selectedIndex == 6 ) graph = 'Sinusoidal'
    if ( document.querySelector(".Waveform").selectedIndex == 7 ) graph = 'Benner wave'
  
	var verticalLable = 'Maximum '+graph+' Frequency (Hz)'
    var colorpic = '#7030A0';

  //use coolors from the data sheet
    if (  inName.substring(inName.search("_")+1)  ==  "3MM" )  colorpic = "#0770C0";
    if (  inName.substring(inName.search("_")+1)  ==  "4MM" )  colorpic = "#00B0F1";
    if (  inName.substring(inName.search("_")+1)  ==  "5MM" )  colorpic = "#02B051";
    if (  inName.substring(inName.search("_")+1)  ==  "6MM" )  colorpic = "#92D051";
    if (  inName.substring(inName.search("_")+1)  ==  "8MM" )  colorpic = "#FFC100";
    if (  inName.substring(inName.search("_")+1)  ==  "10MM")  colorpic = "#E46C0C";
    if (  inName.substring(inName.search("_")+1)  ==  "16MM")  colorpic = "#D19391";

 
 
	for (var d =0; d < inData.length; d++)
	{
		labelData[d] = inData[d].DegOpt;
		Data[d] = inData[d].Freq;
		
		if (inDataAlt != null)  
		{
			DataAlt[d] = inDataAlt[d].Freq; 
		}		
	}
 

if (inDataAlt == null)
{
 
	var dataSetBuilder = 
	[
		{ 
			 data: Data,
			data: Data,
			label:  getSheetFromString(inName).substring(
			getSheetFromString(inName).search("\\("),
			getSheetFromString(inName).length  ).replace("\(","").replace("\)","") + " Tuning",
			
			
			//for dots.
			backgroundColor: 'black',
			borderColor: colorpic,
			borderWidth: 1,
			
			fill: false
		}
	]
}
else
{

//if needed this will make a lighter color. 
    var colorpic2 =  "#" +  ( parseInt( colorpic.substring (1),16 ) + 10000 ).toString(16);
    if (colorpic2.length  == 6 ) colorpic2 = "#0" + colorpic2.substring(1.);
    else if (colorpic2.length  == 5 ) colorpic2 = "#00" + colorpic2.substring(1);

	var dataSetBuilder = 
	[
		{ 
 
				 data: Data,
				label:  getSheetFromString(inName).substring(
				getSheetFromString(inName).search("\\("),
				getSheetFromString(inName).length  ).replace("\(","").replace("\)","") + " Tuning",
				
				//for dots.
          		backgroundColor: 'black',
				borderColor: colorpic, 
				pointBorderColor: "#CDD",
				borderWidth: 1,
				borderDash: [10,5],
				sufix: getSheetFromString(inName ),
				fill: false
		},
		{ 

    
				data: DataAlt,
				label: getSheetFromString(inName+"_2").substring(
				getSheetFromString(inName+"_2").search("\\("),
				getSheetFromString(inName+"_2").length  ).replace("\(","").replace("\)","")  + " Tuning",
				
				//for dots.
				backgroundColor: 'black',
				borderColor: colorpic, 
				pointBorderColor:  "#CDD",
				borderWidth: 1,
				
				sufix: getSheetFromString(inName+"_2"),
				fill: false
		}
	]
}	

 if (CHART) //prevents multiple instances 
 {
	CHART.destroy();
 }
 var chart = 
	new Chart(document.getElementById("line-chart"), {
	  type: 'line',
	  data: {
		labels: labelData,
		datasets: dataSetBuilder
	  },
	  options: {
	   tooltips: {
		   custom: function(tooltip) {
			tooltip.displayColors = false;
		  },
		  callbacks: {
				title: function(context) {return "";} ,//clear title
				label: function(tooltipItem, data) {	

                //dual graph
                var tune = "Tune " + data.datasets[tooltipItem.datasetIndex ].sufix +  " :" ;

                //non dual graph
                if ( ! isScannerNameDouble(name) )   tune = ""
					var multistringText = [ tune  ];
					multistringText.push("   " + tooltipItem. label + " Degrees");
					multistringText.push("    ( Frequency: " +  data.datasets[ tooltipItem.datasetIndex ].data[tooltipItem.index] + ")");
					return multistringText;
			
					}
				}
			},
			maintainAspectRatio: false,
			title: {
			  display: true,
			  text: name.substring(0,getSheetFromString(inName).search("\\(")),
			  fontSize: 18,
			  fontColor: "#111111",
			},
			legend: {
					labels: {
						fontColor: "#111111",
						fontSize: 14
					}
			},
			scales: {
			  yAxes: [{
			   scaleLabel: {
					display: true,
					labelString: verticalLable,
					  fontColor : "#111111",
				  },
				ticks:{
				  min : 0,
                   maxTicksLimit: 10,
				  stepSize : step,
				  fontColor : "#111111",
				  fontSize : 14
				},
				gridLines:{
				  color: "#868686",
				  lineWidth:1,
				  zeroLineColor :"#868686",
				  zeroLineWidth : 2
				},
				//stacked: true
			  }],
			  xAxes: [{
			  scaleLabel: {
					display: true,
					labelString: 'Scan Angle (Degrees Optical peak to peak)',
					  fontColor : "#111111",
				  },
			   // type: 'linear', 
				ticks:{
				 min : 0,
				  max : 60,
				 stepSize : 5,
				  fontColor : "#111111",
				  fontSize : 14
				},
				gridLines:{
				  color: "#868686s",
				  lineWidth:1
				}
			  }]
			},
			 events: ['mousemove', 'mouseout', 'click', 'touchstart', 'touchmove', 'mousedown'],	
		},
		plugins: [{
                    
		afterEvent(chart, args, opts) {

		 var key = "";
			var divisions = 8;//this may change and maybe even per data. 
			var offset = chart.scales['x-axis-0'].getPixelForTick (0);
			var currentX =   args.x  -  offset; //point we are at minus the offset
			var rangeX =  chart.scales['x-axis-0'].getPixelForTick (8)  - offset
			var divisionX = divisions;  
			var spaceX = rangeX / divisionX; //each point is this length
			var markerToLeft = currentX / spaceX;
			var leftTickX =  Math.floor(markerToLeft) 
			var rightTickX =  Math.floor(leftTickX+1) 
			var leftLabelX = chart.scales['x-axis-0'].getPixelForValue ( chart.data.labels[leftTickX] )  - offset;
			var rightLabelX = chart.scales['x-axis-0'].getPixelForValue ( chart.data.labels[rightTickX] ) - offset;
			var DistFromLeftWallX =   currentX- leftLabelX;
 
			
			var  pointVale = (currentX - leftLabelX) / (rightLabelX  - leftLabelX)  * ( chart.data.labels[rightTickX]  - parseInt(chart.data.labels[leftTickX])  )  + parseInt(chart.data.labels[leftTickX]) 
 			
			pointVale = Math.round( pointVale.toFixed(2) );
			
			if ( parseInt(pointVale) > 0) document.querySelector(".XYresult_A").textContent = 'Degrees Optical: ' +  pointVale 
			if ( Math.floor(chart.scales['y-axis-0'].getValueForPixel(args.y))   > 0) document.querySelector(".XYresult_F").textContent = 'Frequency: ' +   Math.floor(chart.scales['y-axis-0'].getValueForPixel(args.y))  
			
			if ( isNaN (pointVale) ) 
			{

				document.querySelector(".XYresult_A").textContent = ' '
				document.querySelector(".XYresult_F").textContent = ' '  
			}  

            //single graph 
			document.querySelector(".XYline1").textContent =   (! isScannerNameDouble(name)  )? interpolateUpByAngle(1, pointVale) + "Hz" 
            
            //dual graph
            : getSheetFromString(inName ).substring(getSheetFromString(inName ).search("\\("), getSheetFromString(inName ).length  ).replace("\(","").replace("\)","") + ": " +  interpolateUpByAngle(1, pointVale)   + "Hz"

            document.querySelector(".XYline2").textContent =   " ";
 
			
			if ( chart.data.datasets[1] != undefined) 
			{
				document.querySelector(".XYline2").textContent = getSheetFromString(inName+"_2" ).substring(getSheetFromString(inName +"_2").search("\\("),getSheetFromString(inName +"_2").length  ).replace("\(","").replace("\)","") + ": " +  interpolateUpByAngle(2, pointVale) + "Hz"
			}
			
			if (document.querySelector(".XYline1").textContent.search("NaN") > -1 )
			{
				document.querySelector(".XYline1").textContent =  " ";
				document.querySelector(".XYline2").textContent =  " ";
			}
 
		},
		
		beforeRender: (obj, options) => {
        }
		,
        beforeDraw: ( c ) => {
    
         if (c.legend.legendItems.length ==2 )    
         {
           c.legend.legendItems[0].fillStyle = 'white';
         }
  
        }

                            
 
	  }]
  
	});
	CHART = chart;
 
}
  
/*************
**************
**  lookups **
**************
**************/


/*******************
********************
**single or double**
********************
********************/
isScannerDouble = function ( )
{

	 return isScannerNameDouble ( document.querySelector(".Scanner").value)
}

isScannerNameDouble = function ( name)
{

	if ( name[0] == "S" )
	{
       return true
    }
	return false;
}



 

/*******************
********************
** guesses objects**
** from strings  **
********************
********************/
getTableFromString = function (scanner)
{

	switch (scanner)
	{
		case undefined:
		case "none":
		return -1;
		
		case "C506_3MM": return C506_3MM;
		case "C506_5MM": return C506_5MM;
		case "C506_10MM": return C506_10MM;
        case "ARC_5MM": return ARC_5MM;
        case "SAT_3MM": return SAT_3MM;
		case "SAT_5MM": return SAT_5MM;
		case "SAT_10MM": return SAT_10MM;
	}
	return -1;
}

/*************************
**************************
** finds sheet names    **
** from drop down values**
**************************
**************************/
getSheetFromString = function (scanner)
{
 
	switch (scanner)
	{
		case undefined:
		case "none":
		return -1;
		
		case "C506_3MM": return   "Compact 506 3mm (30k 2.5kHz)";
		case "C506_5MM": return   "Compact 506 5mm (30k 2.5kHz)";
		case "C506_10MM": return  "Compact 506 10mm (18k 1.5kHz)";
        case "ARC_5MM": return    "Arc 5mm (18k 1.5kHz)";
		case "SAT_3MM": return    "Saturn 1B 56S 3mm (30k 2.5kHz)";
		case "SAT_3MM_2": return  "Saturn 1B 56S 3mm (60k 5kHz)";
		case "SAT_5MM": return    "Saturn 5B 56S 5mm (30k 2.5kHz)";
		case "SAT_5MM_2": return  "Saturn 5B 56S 5mm (60k 5kHz)";
		case "SAT_10MM": return   "Saturn 9B 48S 10mm (18k 1.5kHz)";
		case "SAT_10MM_2": return "Saturn 9B 48S 10mm (24k 2kHz)";
	}
	return -1;
}

/*****************
******************
** findes freq  **
** from angle   **
******************
******************/
lookUpByAngle = function ( line, DegOpt_in)
{
	if (DegOpt_in < 1) return -999; //too small
	if (DegOpt_in > 60) return -999; //too small
	
	var	scanner = getTableFromString ( document.querySelector(".Scanner").value );
	
	if (line == 1) var angle = scanner[document.querySelector(".Waveform").selectedIndex].Angle;
	if (line == 2) var angle = scanner[document.querySelector(".Waveform").selectedIndex].Angle2;
	
	table = getTableFromString ( document.querySelector(".Scanner").value	);
	waveForm  = document.querySelector(".Waveform").selectedIndex;
	
	for ( var d = 0; d < angle.length; d++)
	{
		if (angle[d].DegOpt == DegOpt_in) 
		{
			return angle[d].Freq;	
		}
	}
	return 0; //not found
}

/***********************
************************
** guesses data point **
** based on imput     **
************************
************************/
interpolateUpByAngle = function( line, inNumber )
{
	var itemToRight=0;
	var scanner = getTableFromString ( document.querySelector(".Scanner").value );
	
	if (line == 1) var angle = scanner[document.querySelector(".Waveform").selectedIndex].Angle;
	if (line == 2) var angle = scanner[document.querySelector(".Waveform").selectedIndex].Angle2;
 
	for ( var d = 0; d < angle.length; d++)
	{
		if (angle[d].DegOpt < inNumber) 
		{ 
			 itemToRight=d//item to the righ. no break because we designed funky, works though. 
			 
		}
	}
 
	if (itemToRight == 8) return -1; 
	
	b = angle[ itemToRight+ 1] 
	a = angle[ itemToRight] 
  
	return  pointVale = Math.round(parseInt(a.Freq)  - ( (inNumber - parseInt(a.DegOpt)  ) / ( parseInt(b.DegOpt)  - parseInt(a.DegOpt))  *
	( parseInt(a.Freq)  - parseInt(b.Freq) )  ) );
}

/***********************
************************
** guesses data point **
** based on imput     **
************************
************************/
interpolateUpByFreq = function( scanner, inNumber )
{
	var itemToRight=0;
	var scanner = getTableFromString ( document.querySelector(".Scanner").value );
	for ( var d = 0; d < scanner[document.querySelector(".Waveform").selectedIndex].Angle.length; d++)
	{
 
		if (scanner[document.querySelector(".Waveform").selectedIndex].Angle[d].Freq < inNumber) 
		{ 
			 itemToRight=d//item to the right	
			 break;
		}
	}
	if (itemToRight == 0) return -1; 
	
	b = scanner[document.querySelector(".Waveform").selectedIndex].Angle[ itemToRight+ 1] 
	a = scanner[document.querySelector(".Waveform").selectedIndex].Angle[ itemToRight] 

	return  pointVale = Math.round(parseInt(a.DegOpt)  - ( (inNumber - parseInt(a.Freq)  ) / ( parseInt(b.Freq)  - parseInt(a.Freq))  *
	( parseInt(a.DegOpt)  - parseInt(b.DegOpt) )  ) );
}

  
/**********************
***********************
**  calcs data for   **
** data under graph  **
***********************
***********************/
DisplayResuls = function(  )
{
	var scanner = getTableFromString ( document.querySelector(".Scanner").value );
 
	//dual graph data setes for saturn
	if ( isScannerDouble()  ) 
	{
		DrawChart(scanner[document.querySelector(".Waveform").selectedIndex]. Angle, scanner[document.querySelector(".Waveform").selectedIndex]. Angle2, document.querySelector(".Scanner").value , document.querySelector(".Waveform").value, 100);
 	}
	else DrawChart(scanner[document.querySelector(".Waveform").selectedIndex]. Angle, null, document.querySelector(".Scanner").value , document.querySelector(".Waveform").value, 100 );
	
	CaculateAndShowFreq();
}

  
/***************************
****************************
**  calcs data for        **
** Frequency at 1° Optical**
****************************
****************************/

CaculateAndShowFreq = function(  )
{
	var scanner = getTableFromString ( document.querySelector(".Scanner").value );
	var result1 = undefined;
	var result2 = undefined;
	var info = "Frequency at " + document.querySelector(".Angle").value + "\u00B0 Optical"
	result1 = lookUpByAngle(1, document.querySelector(".Angle").value);

	if (result1 == 0) result1 =  interpolateUpByAngle( 1, document.querySelector(".Angle").value ); 
    if (result1 == -999 ) document.querySelector(".freqResult1").textContent  =  "Angle  Out of range"  ; 
	else document.querySelector(".freqResult1").textContent = info + ": " + result1 + "Hz";

    //dual graph
	if ( isScannerDouble()  ) 
	{
		result1 = lookUpByAngle(1, document.querySelector(".Angle").value);
		if (result1 == 0) result1 =  interpolateUpByAngle( 1, document.querySelector(".Angle").value ); 

        if (result1 == -999 ) document.querySelector(".freqResult1").textContent =  "Angle  Out of range"
        else
		document.querySelector(".freqResult1").textContent = info + " for: " +
		getSheetFromString(document.querySelector(".Scanner").value ).substring(
		getSheetFromString(document.querySelector(".Scanner").value ).search("\\("),
		getSheetFromString(document.querySelector(".Scanner").value ).length  ).replace("\(","").replace("\)","") + " Tuning :"  + result1 + "Hz";
			
		result2 = lookUpByAngle(2, document.querySelector(".Angle").value);
		if (result2 == 0) result2 =  interpolateUpByAngle( 2, document.querySelector(".Angle").value ); 
 
    	if (result2 == -999 ) document.querySelector(".freqResult2").textContent  =  "Angle  Out of range"  ; 
        else
		document.querySelector(".freqResult2").textContent = info  + " for: " +
		getSheetFromString(document.querySelector(".Scanner").value +"_2" ).substring(
		getSheetFromString(document.querySelector(".Scanner").value +"_2" ).search("\\("),
		getSheetFromString(document.querySelector(".Scanner").value +"_2" ).length  ).replace("\(","").replace("\)","") + " Tuning :"  + result2 + "Hz";
	}

    //single graph
	else document.querySelector(".freqResult2").textContent = " ";
}
	
  
/************
*************
**  events **
*************
*************/
  
/*
document.querySelector(".step").addEventListener("keyup", (event) => 
{
 
	if (document.querySelector(".step").value  == "" ||
	isNaN(document.querySelector(".step").value ) )
	document.querySelector(".step").value = 10;
	

	DisplayResuls()
});
*/

document.querySelector(".Waveform").addEventListener("change", (event) => 
{

    //sing graph
	if (! isScannerDouble() ) getData( getTableFromString(document.querySelector(".Scanner").value ) ,document.querySelector(".Waveform").selectedIndex, getSheetFromString(document.querySelector(".Scanner").value) + ranges[document.querySelector(".Waveform").selectedIndex]); 

    //dual graph
    else  
	{
		getData( getTableFromString(document.querySelector(".Scanner").value ) ,	document.querySelector(".Waveform").selectedIndex, getSheetFromString(document.querySelector(".Scanner").value)        + ranges[document.querySelector(".Waveform").selectedIndex]	,0);
		getData( getTableFromString(document.querySelector(".Scanner").value ) ,	document.querySelector(".Waveform").selectedIndex, getSheetFromString(document.querySelector(".Scanner").value+ "_2" ) + ranges[document.querySelector(".Waveform").selectedIndex]  ,1);
	}
});


document.querySelector(".Scanner").addEventListener("change", (event) => 
{
    //sing graph
	if ( ! isScannerDouble() ) getData( getTableFromString(document.querySelector(".Scanner").value ) ,document.querySelector(".Waveform").selectedIndex, getSheetFromString(document.querySelector(".Scanner").value) + ranges[document.querySelector(".Waveform").selectedIndex]); 
	
    //dual graph
    else 
	{
		getData( getTableFromString(document.querySelector(".Scanner").value ) ,	document.querySelector(".Waveform").selectedIndex, getSheetFromString(document.querySelector(".Scanner").value)        + ranges[document.querySelector(".Waveform").selectedIndex]	,0);
		getData( getTableFromString(document.querySelector(".Scanner").value ) ,	document.querySelector(".Waveform").selectedIndex, getSheetFromString(document.querySelector(".Scanner").value+ "_2" ) + ranges[document.querySelector(".Waveform").selectedIndex]  ,1);
	}
});

document.querySelector(".Angle").addEventListener("keyup", (event) => 
{
	if(event.code != "Backspace") 
	{
		if (document.querySelector(".Angle").value  == "" || 
		isNaN(document.querySelector(".Angle").value ) ) 
		document.querySelector(".Angle").value = 1;
		CaculateAndShowFreq();
	}
});


var mouse_down_watcher;
/*document.querySelector(".simData").addEventListener("change", (event) => 
{
	DisplayResuls();
});
*/

document.querySelector(".Wrapper").addEventListener("mousemove", (event) => 
{
	if (mouse_down_watcher) { mouse_down_watcher=false; DisplayResuls();}
});

document.querySelector(".Wrapper").addEventListener("mousedown", (event) => 
{
	 mouse_down_watcher=true;
	 
});

document.querySelector(".Wrapper").addEventListener("mouseup", (event) => 
{
	 mouse_down_watcher=false;
	 
});

/********************
*********************
**  data for email **
*********************
*********************/
document.querySelector(".btnPC").addEventListener("click", (event) => 
{ 
 
  document.querySelector("[id='115201-textarea-1']").textContent =  "Data captured:\n"
  document.querySelector("[id='115201-textarea-1']").textContent += "Scanner : " + document.querySelector(".Scanner").value + "\n"
  document.querySelector("[id='115201-textarea-1']").textContent += "Waveform : " + document.querySelector(".Waveform").value + "\n"
  document.querySelector("[id='115201-textarea-1']").textContent += "Angle : " + document.querySelector(".Angle").value + "\n"
  document.querySelector("[id='115201-textarea-1']").textContent += "Frequency calculation 1 : " + document.querySelector(".freqResult1").textContent + "\n"
  document.querySelector("[id='115201-textarea-1']").textContent += "Frequency calculation 2 : " + document.querySelector(".freqResult2").textContent + "\n"
});
  
 